<template>
    <b-container style="height: 100vh;">
        <b-row align-v="center">
            <b-col
                cols="12"
                md="6"
                offset-md="3"
                style="height: 100vh; display: flex; align-items: center;"
            >
                <b-card class="mb-2 w-100">
                    <b-img
                        src="images/bitacorapp-logo.png"
                        alt="Bitacorapp.com"
                        style="max-width: 100%;"
                    ></b-img>

                    <div>
                        <label for>Usuario</label>
                        <b-form-input type="text" v-model="username" @keyup.enter="login" />
                    </div>

                    <div class="mt-3">
                        <label for>Contraseña</label>
                        <b-form-input type="password" v-model="password" @keyup.enter="login" />
                    </div>

                    <b-button
                        block
                        class="mt-3"
                        variant="confirm"
                        @click="login"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-sign-in" aria-hidden="true"></i>
                        Ingresar
                    </b-button>

                    <b-button block @click="updateSystem" variant="success" size="lg">
                        <i class="fa fa-refresh"></i> Actualizar
                        Sistema
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
        <!-- PopUp de actualización de datos -->
        <app-pop-up
            title="Actualización de datos"
            id="user-info-update-window"
            :options="{ backdrop: 'static', keyboard: false }"
            size="large"
            :close-button="false"
        >
            <template slot="body">
                <component :is="formPart" @saved="onUserInfoSaved" ref="userInfoForm"></component>
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="saveUserInfo" :disabled="inProgress">Confirmar</b-btn>
            </template>
        </app-pop-up>

        <!-- PopUp de notificaciones -->
        <app-pop-up
            :title="`Alertas activas ${notifications.length}`"
            id="notification-window"
            size="extra-large"
            :on-close="() => redirectUrl(destination)"
            :close-button="false"
            :options="{ backdrop: 'static' }"
        >
            <!--  -->
            <template slot="body">
                <div v-if="!!notifications.length">
                    <b-row align-h="center">
                        <b-col class="text-center">
                            <img
                                v-if="
                                    getFileType(
                                        notifications[notificationIndex].image
                                    ) === 'image'
                                "
                                :src="notifications[notificationIndex].image"
                                width="90%"
                                alt
                            />
                            <embed
                                v-if="
                                    getFileType(
                                        notifications[notificationIndex].image
                                    ) === 'pdf'
                                "
                                :src="notifications[notificationIndex].image"
                                width="100%"
                                height="350"
                                frameborder="0"
                                allowfullscreen
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col>
                            <b-checkbox
                                v-if="
                                    !alreadyAccused(
                                        notifications[notificationIndex].id
                                    )
                                "
                                :value="notifications[notificationIndex].id"
                                @change="setAccuse"
                            >
                                Confirmo que he leido y entendido la
                                información
                            </b-checkbox>
                            <b-alert show variant="info" v-else>
                                Lectura y entendimiento confirmados
                                <i class="fa fa-check"></i>
                            </b-alert>
                        </b-col>
                    </b-row>
                    <b-row align-h="center" v-if="notifications.length > 1">
                        <b-col class="text-center">
                            <b-btn-group>
                                <b-btn
                                    variant="secondary"
                                    :disabled="notificationIndex === 0"
                                    size="sm"
                                    @click="prevNotification"
                                >
                                    <i class="fa fa-angle-left"></i>
                                </b-btn>
                                <b-btn
                                    variant="secondary"
                                    :disabled="
                                        notificationIndex ===
                                            notifications.length - 1
                                    "
                                    size="sm"
                                    @click="nextNotification"
                                >
                                    <i class="fa fa-angle-right"></i>
                                </b-btn>
                            </b-btn-group>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <template slot="buttons">
                <b-row>
                    <b-col cols="12">
                        <b-btn
                            block
                            variant="confirm"
                            :disabled="accuseIncomplete"
                            @click="$bus.$emit('notification-window.close')"
                        >
                            <i class="fa fa-check"></i> Confirmo que he leido
                            la información
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { cookies } from '../../../mixin'
import Modal from '../../UI/Controls/Modal/Modal.vue'
import comunicationsRepository from '@repositories/comunications.repository'
import UserInfoPart1Form from '../../Admin/UsersPage/UserInfo/UserInfoPart1Form'
import UserInfoPart2Form from '../../Admin/UsersPage/UserInfo/UserInfoPart2Form'
import usersRepository from '@repositories/users.repository'
export default {
    mixins: [cookies],
    components: {
        appModal: Modal,
        appUserInfoPart1Form: UserInfoPart1Form,
        appUserInfoPart2Form: UserInfoPart2Form,
    },
    data() {
        return {
            username: '',
            password: '',
            notifications: '',
            notificationIndex: 0,
            destination: '',
            readAccuses: [],
            userInfoResolver: '',
            formPart: '',
        }
    },
    validations: {
        username: { required },
        password: { required },
    },
    computed: {
        theUsername() {
            return this.username.split('@')[0]
        },
        theCompanySlug() {
            return this.username.split('@')[1]
        },
        exisitsNotifications() {
            const notifications = this.$store.getters.alertNotifications

            if (!this.user.city)
                return toastr.error('Se debe configurar la ciudad del usuario')

            const validNotifications = notifications
                .filter((item) =>
                    item.profiles.split(',').includes(this.user.profile.slug)
                )
                .filter((item) =>
                    item.cities.split(',').includes(this.user.city.slug)
                )

            this.notifications = validNotifications

            return !!this.notifications.length
        },
        accuseIncomplete() {
            return this.notifications.length !== this.readAccuses.length
        },
    },
    methods: {
        login() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Debe escribir el nombre de usuario y contraseña')
                return false
            }
            const payload = {
                user: this.theUsername,
                pass: this.password,
                companySlug: this.theCompanySlug,
                vigilanceAccess: this.getCookie('_bitacorapp_vigilance_'),
            }

            this.$store
                .dispatch('login', payload)
                .then((data) => {
                    toastr.success('Inicio de sesión correcto')
                    if (!!data.change) {
                        this.$router.push({ name: 'changePassword' })
                        // } else if (data.requireInfoUpdate) {
                        //     this.updateInfo(data);
                    } else {
                        this.processLogin(data)
                    }
                })
                .catch((error) => {
                    toastr.error(error || 'Error al autenticarse')
                })
        },
        saveUserInfo() {
            this.$bus.$emit('userInfoForm.save')
        },
        onUserInfoSaved(data) {
            this.userInfoResolver(data)
        },
        async processLogin(data) {
            if (data.requireInfoUpdate) {
                this.loadUserInfo()
                await this.updateUserInfo(data)
                this.$bus.$emit('user-info-update-window.close')
            }
            const defaultView = data.defaultView
            // this.$store.commit('setMenuOptions', data.menuOptions);

            let destination

            !!data.user.profile.client_required &&
                (destination = 'clientSelection')

            // Validar si la pantalla por defecto esta asignada
            let option
            let currentMenu
            let currentOption
            const menu = this.$store.getters.menu
            if (!!defaultView) {
                option = data.menuOptions.find(
                    (item) => item.to === defaultView
                )
                currentMenu = !!option ? option.menu : menu[0]
            } else {
                currentMenu = menu[0]
            }

            if (!currentMenu) {
                toastr.error('Su perfil no ha sido configurado adecuadamente')
                return false
            }

            currentOption =
                option ||
                data.menuOptions.find((item) => item.menu.id === currentMenu.id)

            this.$store.commit('setCurrentMenu', currentMenu)

            destination = destination || currentOption.to

            this.destination = destination

            // Módulo de notificaciones de mensajes de interes general
            if (this.exisitsNotifications) {
                this.destination = destination
                this.showNotifications()
            } else {
                // !!destination && this.$router.push({ name: destination });
                this.redirectUrl(destination)
            }
        },
        async loadUserInfo() {
            const ur = { ...usersRepository }
            try {
                const { data } = await ur.getUserInfo(this.user.id)

                this.formPart =
                    !Object.keys(data).length || !data.open
                        ? UserInfoPart1Form
                        : UserInfoPart2Form
            } catch (err) {
                this.handleErrors(err)
            }
        },
        updateUserInfo(data) {
            return new Promise((resolve, reject) => {
                this.userInfoResolver = resolve
                this.$bus.$emit('user-info-update-window.open')
            })
        },
        async setAccuse(alertNotificationId) {
            if (!alertNotificationId) return
            try {
                const { data } = await repo.post('comunications/read-accuses', {
                    alertNotificationId,
                })

                if (data.status) {
                    this.readAccuses.push({
                        alertNotificationId: data.result.alert_notification_id,
                        userId: data.result.user_id,
                    })
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
        alreadyAccused(alertNotificationId) {
            return !!this.readAccuses.find(
                (item) => item.alertNotificationId === alertNotificationId
            )
        },
        autoLogin(user, pass) {
            this.username = user
            this.password = pass
            this.login()
        },
        showNotifications() {
            if (!!this.notifications.length) {
                this.$bus.$emit('notification-window.open')
            }
        },
        redirectUrl(destination) {
            !!destination && this.$router.push({ name: destination })
        },
        prevNotification() {
            this.notificationIndex = Math.max(0, this.notificationIndex - 1)
        },
        nextNotification() {
            this.notificationIndex = Math.min(
                this.notifications.length - 1,
                this.notificationIndex + 1
            )
        },
        updateSystem() {
            window.location.reload(true)
        },
        getFileType(fileName) {
            if (!fileName) return ''
            const dictionary = {
                png: 'image',
                jpg: 'image',
                jpeg: 'image',
                gif: 'image',
                pdf: 'pdf',
            }

            const ext = fileName.substr(fileName.lastIndexOf('.') + 1)

            return dictionary[ext.toLowerCase()]
        },
    },
    created() {
        localStorage.clear()
    },
}
</script>
